export function removeSpecialCharacters(term) {
    let withoutSpecialCharacters = term
        .replace(/[àáâãäåæ]/g, 'a')
        .replace(/[ÁÀÂÄÃÆÅ]/g, 'A')
        .replace(/[ç]/g, 'c')
        .replace(/[Ç]/g, 'C')
        .replace(/[ð]/g, 'd')
        .replace(/[éèêë]/g, 'e')
        .replace(/[ÉÈËÊ]/g, 'E')
        .replace(/[ìíîï]/g, 'i')
        .replace(/[ÍÌÎÏ]/g, 'I')
        .replace(/[ñ]/g, 'n')
        .replace(/[Ñ]/g, 'N')
        .replace(/[ðòóôõöø]/g, 'o')
        .replace(/[ÓÔÖØÕÒ]/g, 'O')
        .replace(/[ß]/g, 'ss')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ÚÙÛÜ]/g, 'U')
        .replace(/[ýÿ]/g, 'y')
        .replace(/[Ý]/g, 'Y');
    /* checkout others characters */
    withoutSpecialCharacters = withoutSpecialCharacters
        .replace(/[^a-z0-9 &]/gi, ' ')
        .replace(/(\s+)/g, ' ')
        .replace(/(^\s+)/g, '');
    return withoutSpecialCharacters;
}
export function computeSearchString(str) {
    return str
        .toLowerCase()
        .trim()
        .replace(/%a0/g, '+')
        .replace(/%/g, '')
        .replace(/\//g, '+')
        .replace(/@/g, '%40')
        .replace(/[àáâãäå]/g, 'a')
        .replace(/æ/g, 'ae')
        .replace(/ç/g, 'c')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/ñ/g, 'n')
        .replace(/[òóôõö]/g, 'o')
        .replace(/œ/g, 'oe')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ýÿ]/g, 'y')
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .replace(/</g, '')
        .replace(/\\/g, '')
        .replace(/\^/g, '')
        .replace(/;/g, '')
        .replace(/\|/g, '')
        .replace(/~/g, '')
        .replace(/\[/g, '')
        .replace(/\]/g, '')
        .replace(/\{/g, '')
        .replace(/\}/g, '')
        .replace(/%u20AC/g, 'euro')
        .replace(/`/g, '')
        .replace(/°/g, '')
        .replace(/=/g, '+')
        .replace(/\s/g, '+')
        .replace(/,/g, '+')
        .replace(/!/g, '+')
        .replace(/:/g, '+')
        .replace(/'/g, '+')
        .replace(/\?/g, '')
        .replace(/©/g, '')
        .replace(/¿/g, '')
        .replace(/®/g, '')
        .replace(/\./g, '+')
        .replace(/\.../g, '')
        .replace(/\'/g, '+') // eslint-disable-line no-useless-escape
        .replace(/\’/g, '+') // eslint-disable-line no-useless-escape
        .replace(/#/g, '')
        .replace(/½/g, '1+2')
        .replace(/¢/g, '')
        .replaceAll(',', '+')
        .replaceAll('$', '+')
        .replaceAll('*', '+')
        .replaceAll('&', '+')
        .replace(/\++/g, '+')
        .replace(/\++$/g, '');
}
